import {
    IonButton,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonRow
} from "@ionic/react";
import { trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { setDeselectAll, setDeselectForm } from "../../../store/profileFormAssigned";
import { selectPreselectedForms } from "../../../store/profileFormAssigned/selector/selectPreselectedForms";

export const AssignFormSelected = () => {
    const dispatch = useDispatch();
    const preselectedForms = useSelector(selectPreselectedForms);

    const handleDeselectFormClick = (id: string) => {
        dispatch(setDeselectForm(id));
    }

    const handleDeselectedAllFormClick = async () => {
        dispatch(setDeselectAll());
    }

    return (
        <IonContent>
            <IonRow style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 10px 15px 15px"
            }}
            >
                <div>{preselectedForms.length} plantillas seleccionadas</div>
                <div>
                    {!!preselectedForms.length && (
                        <IonButton fill="solid" size="small" color="danger" onClick={handleDeselectedAllFormClick}>
                            <small>Quitar todos</small>
                            <IonIcon icon={trashOutline} slot="end" />
                        </IonButton>
                    )}
                </div>
            </IonRow>
            <IonList>
                {preselectedForms.map(({ id, name }) => (
                    <IonItem key={id}>
                        <IonLabel>{name}</IonLabel>
                        <IonButton onClick={() => handleDeselectFormClick(id)}>
                            <IonIcon icon={trashOutline} />
                        </IonButton>
                    </IonItem>
                ))}
            </IonList>
        </IonContent>
    );

}